import { z } from "zod/mini"

export const EmptyLegacySchema = z.union([
	z.null(),
	z.object({
		value: z.null(),
	}),
])

export type EmptyLegacy = z.infer<typeof EmptyLegacySchema>
